export const REFRESH_USER_COUNT = 'REFRESH_USER_COUNT';

import { get, put, post, destroy, upload } from 'utils/fetchRequest';

export const uploadImage = async (data) => {
    try {
        const result = await upload('files/training', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getTrainingList = async (searchText) => {
    try {
        const result = await get(`training${searchText ? `?search=${searchText}` : ''}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const getTrainingContent = async (newsId) => {
    try {
        const result = await get(`training/${newsId}`);
        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createTraining = async (data) => {
    try {
        const result = await post('training', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const updateTraining = async (id, data) => {
    try {
        const result = await put(`training/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const deleteTraining = async (id) => {
    try {
        const result = await destroy(`training/${id}`);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const setSpecial = async (id, data) => {
    try {
        const result = await put(`training/special/${id}`, data);

        return result;
    } catch (err) {
        return { error: err };
    }
};
